/* eslint-disable */
import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import EventProductsBody from "components/EventComponents/EventDetailsComponents/EventProducts/EventProductsBody/EventProductsBody";

const EventProducts = () => {
  useEffect(() => {
    document.title = "Event Products";
  }, []);

  return (
    <>
      <main id="app">
        {/* ---- header start ---- */}
        <Header moduleName="events" />
        {/* --- header end --- */}
        <EventProductsBody />
      </main>
    </>
  );
};

export default EventProducts;
